export default "__VITE_ASSET__BMtgADnH__"